<template lang="html">
  <b-container>
    <b-row>
      <b-col ref="dragParent">
        <p>{{ startX }} {{ startY }}</p>
        <p>{{ x }} {{ y }}</p>
        {{ dragObj }}
        <div
          id="dragg"
          v-dragged="e => onDragged(e)"
          :style="dragStyle"
          class="drag-container unselectable"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import dragged from "@/directives/v-dragged/directive";
export default {
  name: "DragTest",
  directives: {
    dragged: dragged
  },
  data() {
    return {
      dragObj: {},
      x: 100,
      y: 100,
      startX: 0,
      startY: 0
    };
  },
  computed: {
    dragStyle() {
      return {
        top: this.y + "px",
        left: this.x + "px"
      };
    }
  },
  mounted() {},
  methods: {
    onDragged(e) {
      console.log(e);
      //if (e.deltaX) {
      //  this.x = this.x + e.deltaX;
      //  this.y = this.y + e.deltaY;
      //}
      if (e.first) {
        var boundingRect = e.el.getBoundingClientRect();
        console.log(boundingRect);
        var parentX = this.$refs.dragParent.getBoundingClientRect().left;
        var parentY = this.$refs.dragParent.getBoundingClientRect().top;
        this.startX = boundingRect.x - parentX;
        this.startY = boundingRect.y - parentY;
      }
      if (e.offsetX) {
        this.x = this.startX + e.offsetX;
        this.y = this.startY + e.offsetY;
      }
      this.dragObj = e;
    }
  }
};
</script>

<style lang="css" scoped>
.drag-container {
  position: absolute;
  top: 100px;
  width: 200px;
  height: 200px;
  background-color: pink;
}

.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
